<div class="container">
    <img class="logo" [src]="source" />
</div>